import { Translatable } from '@spartacus/core';

export enum OrderDetailsEnum {
  ORDER_STATUS_CLOSED = '2',
  CANCEL_WHOLE_ORDER_MODAL = 'cancel-order',
  CANCEL_SELECTED_ITEMS_MODAL = 'cancel-selected-items',
  EDIT_ITEM_QTY_MODAL = 'edit-item-qty',
  CANCEL_ORDER = 'CANCEL_ORDER',
  CHANGE_ORDER = 'CHANGE_ORDER',
  CANCEL_LINE = 'CANCEL_LINE',
  ADD_QTY = 'ADD_QTY',
  SUBTRACT_QTY = 'SUBTRACT_QTY',
}

export interface modalTranslatables {
  modalTitle: Translatable;
  modalDesc?: Translatable;
}

export interface ChangeOrderPayload {
  changeOrderType: string;
  entries: ChangeOrderEntriesPayload[];
  erpOrderNumber: string;
  reasonCode: string;
  shipTo: string;
  erpOrderType?: string;
}

export interface ChangeOrderEntriesPayload {
  changeLineType: string;
  erpLineNumber: string;
  modifiedQuantity: string;
  originalQuantity: string;
  skuCode: string;
  erpOrderType?: string;
}
